<template>
  <div class=" tailor">
    <b-navbar class="navbar navbar-dark bg-orange-custom sticky-top">
      <a class="navbar-brand" href="#">Hazards <i class="fa fa-comments"></i></a>
      <!-- <b-button v-b-tooltip.hover title="Status" pill variant="outline-light" v-on:click="statusFilterChange()" :disabled="!filteredFeatureList.length">{{statusFilter}}</b-button> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-dropdown v-b-tooltip.hover title="User" variant="outline-light" :text="userFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="userFilterChange('User')">All</b-dropdown-item-button>
            <template v-if="currentUser">
              <b-dropdown-item-button v-on:click="userFilterChange(currentUser.fullName)">{{currentUser.fullName}}</b-dropdown-item-button>
            </template>
          </b-dropdown> -->
          <b-dropdown v-b-tooltip.hover title="Type" variant="outline-light" :text="typeFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="typeFilterChange('Type')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in typeFilterSet" :key="index" v-on:click="typeFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown v-b-tooltip.hover title="Risk Classification" variant="outline-light" :text="severityFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="severityFilterChange('Risk Classif.')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in severityFilterSet" :key="index" v-on:click="severityFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
          <!-- <b-dropdown v-b-tooltip.hover title="Status" variant="outline-light" :text="statusFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="statusFilterChange('Status')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in statusFilterSet" :key="index" v-on:click="statusFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown> -->
          <!-- <b-dropdown v-b-tooltip.hover title="Discipline" variant="outline-light" :text="disciplineFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="disciplineFilterChange('Discipline')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in disciplineFilterSet" :key="index" v-on:click="disciplineFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown> -->
          <b-dropdown v-b-tooltip.hover title="Model View" variant="outline-light" :text="hazardTypeFilter.length > 8 ? hazardTypeFilter.substring(0,8) + '...' : hazardTypeFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="hazardTypeFilterChange('Model View')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in hazardTypeFilterSet" :key="index" v-on:click="hazardTypeFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="row">
      <div class="col list-group">
        <template v-if="filteredFeatureList.length">
          <!-- <div v-for="item in filteredFeatureList" :key="item.objectId"> -->
            <a href="#" v-for="item in filteredFeatureList" :key="item.objectId" class="list-group-item list-group-item-action" v-on:click="selectHazardFromList(item.objectId)">
              <div class="row">
                <div class="col-1 ml-3">
                  <i class="fa fa-user"></i>
                </div>
                <div class="col-10">
                  <div class="d-flex w-100 justify-content-between">
                    <p style="margin-bottom: 0.25rem;"><span class="badge badge-secondary badge-pill badge-custom">{{item.objectId}}</span><small> {{item.createdBy}}</small></p>
                    <small class="text-muted">{{getFormattedDate(item.date)}}</small>


                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>"{{item.requestDetails.length > 20 ? item.requestDetails.substring(0, 30) + '...' : item.requestDetails}}"</small>
                      <!-- <small><b>Hazard Id: {{item.objectId}}</b> "{{hazardCommentList.filter(obj => { return obj.objectId == item.objectId })[0].comments[0].comment_details > 0?hazardCommentList.filter(obj => { return obj.objectId == item.objectId })[0].comments[0].comment_details: "none"}}"</small> -->
                    </p>
                    <p style="margin-bottom: 0.25rem;">
                      <!-- <small class="text-muted">{{item.discipline}}</small>&nbsp;&nbsp; -->
                      <small class="text-muted">{{item.hazardType.length > 8 ? item.hazardType.substring(0, 8) + '...' : item.hazardType}}</small>&nbsp;&nbsp;
                      <span class="badge badge-light">{{item.type}}</span>
                      <!-- <template v-if="item.approvalStatus == 'Approved'">
                        <span class="badge badge-success badge-pill">{{item.approvalStatus}}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-danger badge-pill">{{item.approvalStatus}}</span>
                      </template> -->
                      <template v-if="item.severity == 'A'">
                        <span class="badge badge-a badge-pill">{{item.severity}}</span>
                      </template>
                      <template v-if="item.severity == 'B'">
                        <span class="badge badge-b badge-pill">{{item.severity}}</span>
                      </template>
                      <template v-if="item.severity == 'C'">
                        <span class="badge badge-c badge-pill">{{item.severity}}</span>
                      </template>
                      <template v-if="item.severity == 'D'">
                        <span class="badge badge-d badge-pill">{{item.severity}}</span>
                      </template>
                    </p>
                  </div>

                </div>
              </div>
            </a>
          <!-- </div> -->

        </template>
        <template v-else>
          <li class="list-group-item">{{loadingStatus}}</li>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl} from "../../config.js"
import axios from "axios"

export default {
  name: 'SideMenu',
  data () {
    return {
      view: null,
      // webscene: this.$store.state.mapModule.mapWebScene,
      // hazardFeatureList: this.$store.state.mapModule.initialHazards,
      // hazardCommentList: this.$store.state.mapModule.hazardComments,
      // currentHazardId: null,
      hazardIds: [],
      hazardSceneLayer: null,
      highlight: null,
      highlightArray: [],
      disciplineFilterSet: ['Design Management','Civil','Road Design','Drainage','Traffic','Utilities','Structures','Geotech','Tunnel','Ventilation','Design & Engineering','GIS','Project Management','Ground Engineering','CAD','ITS Surface','M&E'],
      disciplineFilter: "Discipline",
      // hazardTypeFilterSet: [
      //   // 'Hazard1',
      //   // 'Hazard2',
      //   // 'Hazard3',
      //   // 'Hazard4',
      //   // 'Hazard5'
      //   "01. Straight Platforms",
      //   "02. Curved Platforms",
      //   "03. Buffer Stops",
      //   "04. Train-Platform Collision",
      //   "05. Collision with Southern Services (Metro) Building",
      //   "06. Train Object/Person Collision",
      //   "07. OHW, Power and Electrocution",
      //   "08. Fire and Ventilation",
      //   "09. Spills, Drainage and Flooding",
      //   "10. O&M, Tunnels, Evacutions"
      // ],
      hazardTypeFilterSet: [
        "01. O&M, Tunnels, Evacutions",
        "02. Train-train collision / Scissors",
        "3A. SYAB Angled",
        "3B. SYAB Ground-Level",
        "04. OSD",
        "05. Collision with southern services building",
        "6A. Straight Platform Entry",
        "6B. Straight Platform Midpoint",
        "6C. Straight Platform End",
        "7A. Curved Platform Entry",
        "7B. Curved Platform Midpoint",
        "7C. Curved Platform End",
      ],
      // hazardTypeFilter: "Hazard Type",
      hazardTypeFilter: "Model View",
      statusFilterSet: ['Approved','Pending'],
      statusFilter: "Status",
      // severityFilterSet: ['Critical', 'Major', 'Minor'],
      severityFilterSet: ['A', 'B', 'C', 'D'],
      severityFilter: "Risk Classif.",
      typeFilterSet: ['Type 1', 'Type 2', 'Type 3', 'Type 4', 'Type 5'],
      typeFilter: "Type",
      userFilterSet: [],
      userFilter: "User",
      loadingStatus: "Loading..."
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentHazardId: {
      get() {
        return this.$store.state.mapModule.currentHazardId
      }
    },
    hazardFeatureList: {
      get() {
        return this.$store.state.mapModule.initialHazards
      }
    },
    hazardLayerId: {
      get() {
        return this.$store.state.mapModule.staticHazardLayerId
      }
    },
    currentUser: {
      get() {
        if(this.$store.state.mapModule.user){
          return this.$store.state.mapModule.user
        }
        else {
          return false;
        }
      }
    },
    filteredFeatureList: {
      get() {
        console.log(this.currentUser);
        const current = this
        var finalList = this.hazardFeatureList
        // if (this.disciplineFilter == "Discipline") {
        //   finalList =  this.hazardFeatureList
        // }
        // else {
        //   finalList = this.hazardFeatureList.filter(obj=>obj.discipline == this.disciplineFilter)
        // }
        if (current.hazardTypeFilter == "Model View") {
          finalList =  current.hazardFeatureList
        }
        else {
          finalList = current.hazardFeatureList.filter(obj=>obj.hazardType == current.hazardTypeFilter)
        }
        // if (current.statusFilter != "Status") {
        //   finalList = finalList.filter(obj=>obj.approvalStatus == current.statusFilter)
        // }
        if (current.severityFilter != "Risk Classif.") {
          finalList = finalList.filter(obj=>obj.severity == current.severityFilter)
        }
        // if (current.userFilter != "User") {
        //   finalList = finalList.filter(obj=>obj.createdBy == current.userFilter)
        // }
        if (current.typeFilter != "Type") {
          finalList = finalList.filter(obj=>obj.type == current.typeFilter)
        }
        // var filterLayer = {
        //   // user: current.userFilter == "User"? "": current.userFilter,
        //   type: current.typeFilter == "Type"? "": current.typeFilter,
        //   severity: current.severityFilter == "Risk Classif." ? "" : current.severityFilter,
        //   hazardType: current.hazardTypeFilter == "Model View" ? "" : current.hazardTypeFilter
        // }
        // this.userFilterSet= [this.currentUser.fullName]
        // current.$store.commit("mapModule/resetInitialHazards")
        // current.$store.commit("mapModule/setFilterLayer", filterLayer)

        // if (current.hazardTypeFilter != "Hazard Type" || current.severityFilter != "Severity" || current.userFilter != "User") {
        // if (current.hazardTypeFilter || current.severityFilter || current.userFilter ) {
        // if (current.currentUser) {
        // var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
        // if(current.hazardFeatureList && current.webSceneLoadedFlag && isNaN(parseInt(objectId))){
        //   const vue = document.getElementById("map").__vue__
        //   const sceneView = vue.view
        //   var hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId)
        //   // current.hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId);
        //   // sceneView.map.remove(current.hazardSceneLayer);
        //   sceneView.map.remove(hazardSceneLayer);
        //   // sceneView.map.allLayers.refresh()
        //   current.$store.dispatch("mapModule/fetchHazardLayer", filterLayer).then(currentHazardLayer=>{
        //     // console.log("just fetched the new hazard Layer");
        //     sceneView.map.add(currentHazardLayer);
        //     // console.log(currentHazardLayer);
        //     // console.log(sceneView.map.allLayers);
        //   })
        // }
        return finalList
      }
    },
    webSceneLoadedFlag: {
      get() {
        return this.$store.state.mapModule.mapWebSceneLoadFlag
      }
    }
  },
  watch: {
    webSceneLoadedFlag: function() {
      const current = this
      console.log("webscene watch1");

      if (current.webSceneLoadedFlag) {
        console.log("webscene watch2");
        // current.loadHazardList()
        console.log(current.webSceneLoadedFlag);
        // current.userFilterSet= [current.$store.state.mapModule.user.fullName]
        current.loadHazardList_noArcGIS()
      }
    },
    hazardFeatureList: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const view = vue.view
      console.log(current.hazardFeatureList);
      if (current.hazardFeatureList && current.webSceneLoadedFlag) {
        console.log(window.location.href.split("/"));
        var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
        if (!isNaN(parseInt(objectId))) {
          // current.selectHazardFromList(objectId)
          view.whenLayerView(current.hazardSceneLayer).then(()=>{
            console.log("SceneView load complete = " + view.isResolved());
            current.selectHazardFromList(parseInt(objectId))
          })
        }
      }
    }
  },
  methods: {
    loadHazardList_noArcGIS: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      // current.hazardSceneLayer = sceneView.map.allLayers.filter(function(item) {
      //   return item.id === current.hazardLayerId;
      // }).items[0];
      current.hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId);
      // current.hazardSceneLayer = current.webscene.allLayers.filter(function(item) {
      //   return item.id === current.hazardLayerId;
      // }).items[0];
      console.log(current.hazardSceneLayer);
      current.$store.commit("mapModule/resetInitialHazards")
      var currentObjectId = 0;
      current.hazardSceneLayer.graphics.items.forEach(item => {
        var featureObject = {}
        if(item.attributes.id != currentObjectId){
          currentObjectId = item.attributes.id
          featureObject["objectId"] = item.attributes.id
          featureObject["discipline"] = item.attributes.discipline
          featureObject["priority"] = item.attributes.priority
          featureObject["severity"] = item.attributes.severity
          featureObject["createdBy"] = item.attributes.hazardCreatedBy
          featureObject["userName"] = item.attributes.userName
          featureObject["addressedTo"] = item.attributes.addressedTo
          featureObject["hazardType"] = item.attributes.hazardType
          featureObject["type"] = item.attributes.type
          featureObject["requestDetails"] = item.attributes.requestDetails
          featureObject["approvalStatus"] = item.attributes.approvalState
          featureObject["date"] = item.attributes.date
          featureObject["requestCreated"] = item.attributes.requestCreated
          featureObject["responseRequiredBy"] = item.attributes.responseRequiredBy
          featureObject["updateBy"] = item.attributes.updateBy
          featureObject["fileName"] = item.attributes.fileName
          featureObject["fileId"] = item.attributes.fileId
          current.hazardIds.push(item.attributes.id)
          current.$store.commit("mapModule/insertInitialHazards", featureObject)
        }

      })
      current.loadingStatus = (current.hazardSceneLayer.graphics.items.length==0)?"No Data Found":""
      current.$store.dispatch("mapModule/fetchHazardComments", {objectIds: current.hazardIds})
      console.log(current.hazardSceneLayer);

    },
    selectHazardFromList:function(hazardId) {
      const current = this
      const vue = document.getElementById("map").__vue__
      const view = vue.view
      console.log(hazardId);
      console.log(current.highlightArray);
      current.highlightArray.forEach(item=>{
        item.remove()
      })
      current.hazardSceneLayer = view.map.findLayerById(current.hazardLayerId);
      // store the hazardId and the content of the hazard/comments on the store variables
      // selected Hazard and selected comments
      // if (!current.hazardSceneLayer) {
      //   current.hazardSceneLayer = view.map.allLayers.filter(function(item) {
      //     return item.id === current.hazardLayerId;
      //   }).items[0];
      // }
      if (current.currentHazardId == hazardId) {
        current.$store.commit("mapModule/clearAttachments")
        current.$store.commit("mapModule/setCurrentHazardId", null)
        current.toggleFlexContainer()
      }
      else {
        console.log(current.currentHazardId);
        current.closeFlexContainer()
        current.$store.commit("mapModule/clearAttachments")
        current.$store.dispatch("mapModule/setCurrentHazardDetails", hazardId)
        // current.getFlexData(hazardId)
        console.log(current.currentHazardId);
        current.openFlexContainer()
        // const vue = document.getElementById("map").__vue__
        // const view = vue.view
        console.log(vue);
        console.log(view);
        loadModules(["esri/tasks/support/Query"],{ css: true })
        .then(([Query]) => {
          console.log(current.hazardSceneLayer);
          view.whenLayerView(current.hazardSceneLayer).then(function(hazardLayerView){
            // var selectedFeature = current.hazardSceneLayer.graphics.items.filter(obj=>{
            //   return obj.attributes.id === hazardId
            // })[0]
            var selectedFeature = current.hazardSceneLayer.graphics.items.filter(obj=>{
              return obj.attributes.id === hazardId
            })
            console.log(selectedFeature);
            // if (selectedFeature) {
            //   current.highlightArray[hazardId] = hazardLayerView.highlight(selectedFeature);
            //   var center = selectedFeature.geometry
            //   var tilt = view.camera.tilt
            //   view.goTo({
            //     speedFactor: 0.5,
            //     zoom: 21,
            //     tilt: tilt,
            //     center: center
            //   });
            // }

            if (selectedFeature.length != 0) {
              selectedFeature.forEach((selectedFeatureItem, index) => {
                current.highlightArray[index] = hazardLayerView.highlight(selectedFeatureItem);
                // current.highlightArray[hazardId] = hazardLayerView.highlight(selectedFeatureItem);
                var center = selectedFeatureItem.geometry
                var tilt = view.camera.tilt
                view.goTo({
                  speedFactor: 0.5,
                  zoom: 18,
                  tilt: tilt,
                  center: center
                });
              });
              console.log(current.highlightArray);

            }
            else {
              current.closeFlexContainer()
            }
            // if (current.highlight) {
            //   current.highlight.remove();
            // }
            // current.highlight = hazardLayerView.highlight([hazardId]);
          })



        })

      }
      // connect to database, get the data, store to state, then open the flexContainer
    },
    clearTextData:()=>{
      var comment = document.getElementById("newCommentTextArea")
      if (comment) {
        comment.innerHTML = ""
        comment.value = ""
      }
    },
    toggleFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.toggle("col-9")
      flexContainer.classList.toggle("displayNone")
      map.classList.toggle("col-6")
    },
    closeFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
    },
    openFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.remove("col-9")
      map.classList.add("col-6")
      flexContainer.classList.remove("displayNone")
    },
    disciplineFilterChange: function(selection) {
      this.disciplineFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.disciplineFilterChange("Discipline")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
    },
    hazardTypeFilterChange: function(selection) {
      // console.log(selection);
      // console.log(selection.length);
      // console.log(selection.substring(0,8));
      // this.hazardTypeFilter = selection.length > 8 ? selection.substring(0,8) + '...' : selection
      this.hazardTypeFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.hazardTypeFilterChange("Model View")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }
    },
    statusFilterChange: function(selection) {
      // ++this.statusFilterCounter
      // this.statusFilter = this.statusFilterSet[this.statusFilterCounter%3]
      this.statusFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.statusFilterChange("Status")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
    },
    severityFilterChange: function(selection) {
      // ++this.severityFilterCounter
      // this.severityFilter = this.severityFilterSet[this.severityFilterCounter%3]
      // severityFilter.length > 8 ? severityFilter.substring(0,8) + '...' :
      this.severityFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.severityFilterChange("Risk Classif.")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }
    },
    typeFilterChange: function(selection) {
      // ++this.typeFilterCounter
      // this.typeFilter = this.typeFilterSet[this.typeFilterCounter%3]
      this.typeFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.typeFilterChange("Type")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
      else {
        this.featureFilter()
      }

    },
    featureFilter: function(){
      const current = this
      var filterLayer = {
        // user: current.userFilter == "User"? "": current.userFilter,
        type: current.typeFilter == "Type"? "": current.typeFilter,
        severity: current.severityFilter == "Risk Classif." ? "" : current.severityFilter,
        hazardType: current.hazardTypeFilter == "Model View" ? "" : current.hazardTypeFilter
      }
      var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
      if(current.hazardFeatureList && current.webSceneLoadedFlag && isNaN(parseInt(objectId))){
        const vue = document.getElementById("map").__vue__
        const sceneView = vue.view
        var hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId)
        // current.hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId);
        // sceneView.map.remove(current.hazardSceneLayer);

        // sceneView.map.allLayers.refresh()
        current.$store.dispatch("mapModule/fetchHazardLayer", filterLayer).then(currentHazardLayer=>{
          // console.log("just fetched the new hazard Layer");
          sceneView.map.remove(hazardSceneLayer);
          sceneView.map.add(currentHazardLayer);
          // console.log(currentHazardLayer);
          // console.log(sceneView.map.allLayers);
        })
      }
    },
    userFilterChange: function(selection) {
      // ++this.statusFilterCounter
      // this.statusFilter = this.statusFilterSet[this.statusFilterCounter%3]
      this.userFilter = selection
      if (this.filteredFeatureList.length == 0) {
        this.userFilterChange("User")
        this.$notify({
          group: 'errors',
          title: "Empty List",
          type: 'error',
          text: "No items in the list for "+selection,
          width: 500,
          duration: 1500
        })
      }
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
  },
}
</script>

<style>
  .panel-result {
    cursor: pointer;
    margin: 2px 0;
  }

  .panel-result:hover,
  .panel-result:focus,
  .panel-result.selected {
    background-color: rgba(200, 200, 200, 0.6);
  }
  .tailor {
    height: 93vh;
    max-height: 93vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .badge-custom {
    padding-right: 0.45em !important;
    padding-left: 0.45em !important;
    padding: 0.45em 0.45em !important;
  }

  .bg-orange-custom {
    background-color: #E66200 !important;
  }

  .badge-a {
      color: #fff;
      background-color: #ff0000;
  }

  .badge-b {
      color: #fff;
      background-color: #ff9900;
  }

  .badge-c {
      color: #333333;
      background-color: #ffff00;
  }

  .badge-d {
      color: #fff;
      background-color: #99cc00;
  }

</style>
